import { ListItemText, styled } from '@mui/material';

import { TAppraisalGroupSummaryDto } from '@app-velocity/av-api-v2';

import { FileIcon, FrameIcon } from '@app-velocity/icons';

import { AppraisalsCount } from '../../../AppraisalsCount';

export type SingleAppraisalItemTextProps = {
  appraisal: TAppraisalGroupSummaryDto;
};

const StyledData = styled('div')<{ main?: boolean }>(({ main, theme }) => ({
  display: 'flex',
  alignItems: 'center',
  whiteSpace: 'nowrap',
  gap: theme.spacing(1),
  fontWeight: main ? 600 : 400,
  color: 'var(--text-text-primary-color)',
}));

const StyledIconContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: '0 0 auto',
  svg: {
    flex: 1,
    fill: 'var(--text-text-primary-color)',
  },
});

const StyledText = styled('span')({
  textOverflow: 'ellipsis',
  overflow: 'hidden',
});

export const SingelAppraisalItemText = ({
  appraisal,
}: SingleAppraisalItemTextProps) => {
  const nodeName = appraisal.nodeName?.split('--||--')[0];

  return (
    <ListItemText
      // backwards compability
      primary={
        appraisal.pageName ? (
          <StyledData main>
            <StyledIconContainer>
              <FileIcon />
            </StyledIconContainer>
            <StyledText>{appraisal.pageName}</StyledText>
          </StyledData>
        ) : (
          <StyledData main>
            <StyledIconContainer>
              <FrameIcon />
            </StyledIconContainer>
            <StyledText>{nodeName}</StyledText>
          </StyledData>
        )
      }
      secondary={
        <div>
          {appraisal.pageName ? (
            <StyledData>
              <StyledIconContainer>
                <FrameIcon />
              </StyledIconContainer>
              <StyledText>{nodeName}</StyledText>
            </StyledData>
          ) : null}
          <AppraisalsCount
            errors={appraisal.errors || 0}
            warnings={appraisal.warnings || 0}
            info={appraisal.info || 0}
          />
        </div>
      }
    />
  );
};
